import { FieldNames, FormType } from "@/enums";
import { IIntake, ISelectOption } from "@/interfaces";

type FlatFormField = { property: { name: string }; values?: { id: string; dependsOnPropertyValues?: string[] }[] };

export const getProductLineOptions = (
    formLookups: { intake?: IIntake },
    flatFormFields: FlatFormField[],
    getPropertyValueDisplay: (formType: FormType, fieldName: FieldNames, id: string) => string,
    fieldName: FieldNames.ProductLine1 | FieldNames.ProductLine2,
    parentValue: string
  ): ISelectOption[] => {
    const field = flatFormFields.find(
      ({ property }: { property: { name: string } }) => property.name === fieldName
    );

    const allowedIds = new Set(
      (field?.values ?? [])
        .filter(
          ({ dependsOnPropertyValues }: { dependsOnPropertyValues?: string[] }) => (
            !dependsOnPropertyValues?.length ||
            dependsOnPropertyValues.indexOf(parentValue) !== -1
          )
        )
        .map(({ id }: { id: string }) => id)
    );

    return Object.keys(formLookups?.intake?.[fieldName] ?? {})
      .filter((id) => allowedIds.has(id))
      .map((id) => ({
        value: id,
        label: getPropertyValueDisplay(
          FormType.Intake,
          fieldName,
          id
        ),
      }));
  };